var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projectileFrame comWidth"},[_c('div',[_c('div',{staticClass:"scu"},[_vm._v("登錄成功")]),_vm._v(" "),_c('el-row',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.continueShopping}},[_vm._v("繼續購物")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.returnOne}},[_vm._v("返回上一頁")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e31243","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectileFrame.vue
// module id = null
// module chunks = 